import { z4 } from '@fiverr-private/forms';
import { translate } from '../translate';
import { USERNAME_FIRST_SYMBOL_REGEX, USERNAME_REGEX, USERNAME_MINIMAL_LENGTH } from './constants';

export const createProfileSetupSchema = () =>
    z4.object({
        username: z4
            .string()
            .refine(
                (value) => {
                    const firstLetter = value[0] || '';
                    return USERNAME_FIRST_SYMBOL_REGEX.test(firstLetter);
                },
                {
                    error: translate('validation.username.format'),
                }
            )
            .refine((value) => value.length >= USERNAME_MINIMAL_LENGTH, {
                error: translate('validation.username.too_short'),
            })
            .refine((value) => USERNAME_REGEX.test(value), {
                error: translate('validation.username.format'),
            }),
    });

export type ProfileSetupFormSchema = z4.infer<ReturnType<typeof createProfileSetupSchema>>;
